"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _actions = require("./actions");

var _DateTimeFormatOption = _interopRequireDefault(require("./DateTimeFormatOption"));

var _handleActions;

var initialState = (0, _immutable.fromJS)({
  dateTimeFormatOptions: (0, _immutable.Map)(),
  monthFormatOptions: (0, _immutable.Map)()
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchDateTimeFormatOptionsActionTypes.SUCCESS, function (state, action) {
  var dateTimeFormatOptions = action.payload.data.options;
  var selectedLanguage = action.payload.props.language;
  return state.setIn(['dateTimeFormatOptions', selectedLanguage], dateTimeFormatOptions.reduce(function (acc, item) {
    if (item.length === 2) {
      return acc.set(item[0], new _DateTimeFormatOption.default({
        format: item[0],
        sampleDateString: item[1]
      }));
    }

    return acc;
  }, (0, _immutable.Map)()));
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchMonthFormatOptionsActionTypes.SUCCESS, function (state, action) {
  var monthFormatOptions = action.payload.data.options;
  var selectedLanguage = action.payload.props.language;
  return state.setIn(['monthFormatOptions', selectedLanguage], monthFormatOptions.reduce(function (acc, item) {
    if (item.length === 2) {
      return acc.set(item[0], new _DateTimeFormatOption.default({
        format: item[0],
        sampleDateString: item[1]
      }));
    }

    return acc;
  }, (0, _immutable.Map)()));
}), (0, _defineProperty2.default)(_handleActions, _actions.CreateCustomDateTimeFormatOptionActionTypes.SUCCESS, function (state, action) {
  var customFormatOption = action.payload.data.option;
  var selectedLanguage = action.payload.props.language_str;
  return state.setIn(['monthFormatOptions', selectedLanguage, customFormatOption[0]], new _DateTimeFormatOption.default({
    format: customFormatOption[0],
    sampleDateString: customFormatOption[1]
  }));
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;